<script>
export default {
    name: "LinesInThePressBottom"
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="339.41" height="293.32" viewBox="0 0 339.41 293.32">
        <g id="Group_1514" data-name="Group 1514" transform="translate(0.432 0.5)">
            <path id="Path_1098" data-name="Path 1098" d="M0,0H335.937" transform="translate(1.463)" fill="none" stroke="#fff" stroke-width="1"/>
            <path id="Path_1099" data-name="Path 1099" d="M338.545,0l-168.9,291.824L0,0" fill="none" stroke="#fff" stroke-width="1"/>
        </g>
    </svg>
</template>
